const ActionType = Object.freeze({
    ANIMATION: 'ANIMATION',
    AUDIO: 'AUDIO',
    TEXT: 'TEXT',
    DELAY: 'DELAY',
    INPUT: 'INPUT',
    CODE: 'CODE',
});

export default ActionType;
